import * as React from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';
const Success = React.memo((props) => (<Icon component={() => (<svg focusable="false" width="1em" height="1em" fill="#20C78A" viewBox="0 0 16 16">
        <path d="M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm4.167 4.319a.6.6 0 0 0-.85 0L6.956 9.68 4.754 7.478a.602.602 0 1 0-.851.85l2.595 2.596a.65.65 0 0 0 .919 0l4.75-4.756a.6.6 0 0 0 0-.85z"/>
      </svg>)} {...props}/>));
export default Success;
